import * as tslib_1 from "tslib";
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { action, select } from 'satcheljs/lib/legacy';
import { getOptionsForFeature, lazyCreateOrUpdateOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
export default select({
    optionState: function () { return store; },
    userOptions: function () {
        return getOptionsForFeature(OwsOptionsFeatureType.SurfaceActions);
    },
})(action('saveSurfaceActionsOption')(function saveSurfaceActionsOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.readSurfaceActions = getFallbackValueIfNull(optionState.readSurfaceActions, userOptions.readSurfaceActions);
                    userOptions.readSurfaceAddins = getFallbackValueIfNull(optionState.readSurfaceAddins, userOptions.readSurfaceAddins);
                    userOptions.composeSurfaceActions = getFallbackValueIfNull(optionState.composeSurfaceActions, userOptions.composeSurfaceActions);
                    userOptions.composeSurfaceAddins = getFallbackValueIfNull(optionState.composeSurfaceAddins, userOptions.composeSurfaceAddins);
                    logUserSavedSettings(userOptions.readSurfaceActions.length, userOptions.readSurfaceAddins.length, userOptions.composeSurfaceActions.length, userOptions.composeSurfaceAddins.length);
                    return [4 /*yield*/, lazyCreateOrUpdateOptionsForFeature.importAndExecute(OwsOptionsFeatureType.SurfaceActions, userOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
function logUserSavedSettings(readStaticCount, readAddinCount, composeStaticCount, composeAddinCount) {
    var _a = datapoints.CSACountUserSaveSettings.datapoint, name = _a.name, customData = _a.customData;
    logUsage(name, customData(truncateCount(readStaticCount), truncateCount(readAddinCount), truncateCount(composeStaticCount), truncateCount(composeAddinCount)));
}
function truncateCount(value) {
    // For datapoint aggregation in azure we can only have 24 unique possible values for any custom data key.
    // Accounting for 0, bucket all values >=23 as "23".
    return value >= 23 ? 23 : value;
}
//# sourceMappingURL=saveSurfaceActionsOption.js.map